import React, { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl'
import { Hidden, Collapse } from '@material-ui/core';

import TrackingNumberLink from '../components/TrackingNumberLink';
import CarrierIcon from '../components/CarrierIcon';
import SignatureRequiredTag from '../components/SignatureRequiredTag';
import { AbbreviatedDestinationAddress } from '../components/DestinationAddress';

import { makeBtStyles } from '../Theme';

import { CardSection } from './Card';
import { BtLink } from '../components/BtLink';
import classnames from 'classnames';

import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import Icon from '../components/Icon';

const useStyles = makeBtStyles( theme => ({
  carrierIcon: {
    height: '35px',
    opacity: '0.5',
    filter: 'grayscale(1)',
    width: 'auto !important',
      paddingRight: '8px',
    '&.carrierIconSvg': {
      maxHeight: '14px'
    },
    '&.carrierIconText': {
      fontWeight: '300'
    }
  },
  contentLabel: {
    margin: '10px 0px',
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: '8px',
    display: 'block',
  },
  destinationTrackingSection:{
    minHeight: '85px',
    paddingLeft: '53px',
    borderBottom: '0.5px solid #DFE3E8',
    borderTop: '0.5px solid #DFE3E8',
    display: 'flex',
    flexDirection: 'row',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '40px',
      borderTop: 'none',
      marginTop: '-20px',
      display: 'block'
    }
  },  
  finalDestination:{
    width: '300px',
    marginRight: '20px',
    fontSize: '14px',
    letterSpacing: '0.13px'
  },
  signatureRequired: {
    margin: '5px 0px 5px',
    fontSize: '9px',
  },
  trackingNumber: {
    fontSize: '14px',
    [theme.breakpoints.down('md')]: {
      width: '150px'
    }
  },
  trackingNumberWrapper: {
    width: '240px'
  },
  icon: {
    color: theme.colors.main,
    position: 'absolute',
    right: '40px',
    fontSize: '20px'
  }
  })
);

const useToggleStyles = makeBtStyles( theme => ({
  collapseToggle: {
    textDecoration: 'none !important',
    color: 'black',
    fontSize: '14px',
    fontWeight: '500',
    borderTop: '1px solid #DFE3E8',
    width: '100%',
    padding: '20px 30px 20px 40px',
  },
  showMore: {
    display: 'inline-block',
  }
}));


export default function DestinationTrackingSection({ className }:{
  className?: string
}) {
  const classes = useStyles();
  const toggleClasses = useToggleStyles();

  const [showMore,setShowMore] = useState(false);
  const toggleMore = useCallback( () => setShowMore( oldShowMore => !oldShowMore ), [] );

  return ( <>
    <Hidden smDown> 
      <CardSection className={classes.destinationTrackingSection}>
        <div className={classes.finalDestination}>
          <label className={classes.contentLabel}>
            <FormattedMessage description="layout03.destinationTrackingSection.destinationLabel" defaultMessage="Final Destination" />
          </label>
          <AbbreviatedDestinationAddress />
        </div>
      
        <div className={classes.trackingNumberWrapper}>
          <label className={classes.contentLabel}>
            <FormattedMessage description="layout03.destinationTrackingSection.trackingNumberLabel" defaultMessage="Carrier Tracking" />
          </label>
          <div className={classes.trackingNumber}>
            <CarrierIcon className={classes.carrierIcon} fallbackToName />
            <TrackingNumberLink />
            <SignatureRequiredTag className={classes.signatureRequired}/>

          </div>
        </div>
      </CardSection>
    </Hidden>

    <Hidden mdUp> 
      <BtLink onClick={toggleMore} className={classnames(toggleClasses.showMore, toggleClasses.collapseToggle)}>
        <FormattedMessage description="layout03.mobile.shipmentInformation" defaultMessage="Shipment Information" />
        { showMore ? <>
          <Icon icon={faChevronUp} className={classes.icon} />
        </>:<>
          <Icon icon={faChevronDown} className={classes.icon} />
        </>}
      </BtLink>
      <Collapse in={showMore}>
        <CardSection className={classes.destinationTrackingSection}>
          <div className={classes.trackingNumberWrapper}>
            <label className={classes.contentLabel}>
              <FormattedMessage description="layout03.mobile.carrierTracking" defaultMessage="Carrier Tracking" />
            </label>
            <div className={classes.trackingNumber}>
              <CarrierIcon className={classes.carrierIcon} fallbackToName />
              <TrackingNumberLink />
              <SignatureRequiredTag className={classes.signatureRequired}/>

            </div>
          </div>

          <div className={classes.finalDestination}>
            <label className={classes.contentLabel}>
              <FormattedMessage description="layout03.mobile.destinationLabel" defaultMessage="Final Destination" />
            </label>
            <AbbreviatedDestinationAddress />
          </div>
        </CardSection>
      </Collapse>
    </Hidden>
    </>
  )
  
}